import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCardHero = styled.div.withConfig({
  displayName: "CardHero__StyledCardHero",
  componentId: "x3pc56-0"
})(props => {
  return Object.assign({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    overflow: 'hidden'
  }, props.$cssStyles);
});
export const CardHero = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledCardHero, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};